import Reveal from "@/components/base/Reveal";

const points = [
  {
    icon: "ri-eye-off-line",
    title: "Quase ninguém lá",
    desc: "São pouquíssimas operações rodando com resultado. Menos concorrência = mais oportunidade.",
  },
  {
    icon: "ri-lock-unlock-line",
    title: "Precisa de gestor pra liberar BM",
    desc: "No Kwai não é chegar e criar conta. Você precisa de alguém com acesso pra liberar sua BM. A gente faz isso.",
  },
  {
    icon: "ri-graduation-cap-line",
    title: "A gente ensina a rodar",
    desc: "A maioria dos gestores libera a BM e some. A gente te ensina o passo a passo pra subir sua primeira campanha.",
  },
];

export default function BioWhy() {
  return (
    <section className="py-16 md:py-20 px-4 bg-background-100/30">
      <div className="max-w-lg mx-auto">
        <Reveal>
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-center text-foreground-950 mb-3">
            Por que o Kwai?
          </h2>
          <p className="text-center text-foreground-600 text-sm mb-10">
            Um canal praticamente inexplorado por anunciantes de performance.
          </p>
        </Reveal>

        <div className="space-y-4">
          {points.map((p, i) => (
            <Reveal key={p.title} delay={i * 100}>
              <div className="flex items-start gap-4 p-5">
                <div className="w-10 h-10 rounded-lg bg-primary-500/10 flex items-center justify-center shrink-0">
                  <i className={`${p.icon} text-primary-400 text-lg`}></i>
                </div>
                <div>
                  <h3 className="font-semibold text-foreground-950 mb-1">{p.title}</h3>
                  <p className="text-sm text-foreground-600 leading-relaxed">{p.desc}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}